import { Table, Tbody, Thead } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Td, Th, Tr } from './factory';

export const EmptyTable: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Table width="100%" borderRadius="6px" shadow="0 0 20px 0 rgba(46,61,73,0.15)" mb={4}>
      <Thead>
        <Tr>
          <Th />
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>{t('table.noResults')}</Td>
        </Tr>
      </Tbody>
    </Table>
  );
};
